import React from 'react'
import Button from '../../components/Button'
import Card from '../../components/Card'
import CheckRole from '../../components/CheckRole'
import { H2, PageHeading } from '../../components/Headings'
import Modal from '../../components/Modal'
import useLocale from '../../hooks/useLocale'
import { Input } from '../../components/FormComponents'
import { Link } from 'react-router-dom'
import useLegalTexts from '../../hooks/useLegalTexts'
import DangerButton from '../../components/DangerButton'
import Paginator from '../../components/Paginator'

function LegalTextsList() {
	const { l } = useLocale()
	const {
		openModal,
		showModal,
		handleAddLegal,
		handleDelete,
		legalTexts,
		closeModal,
		nameRef,
		search,
		setSearch,
		setPage,
	} = useLegalTexts()

	return (
		<>
			<PageHeading image='/img/legal.svg' title={l('legal_texts')}>
				<CheckRole has='add_legal_texts'>
					<Button onClick={openModal}>{l('add')}</Button>
				</CheckRole>
			</PageHeading>
			<Card>
				<Input
					className='w-64'
					value={search}
					onChange={e => setSearch(e.target.value)}
					placeholder={l('search')}
				/>
				<table className='w-full'>
					<thead>
						<tr className='text-left border-b border-gray-600'>
							<th>{l('name')}</th>
							<th>{l('actions')}</th>
						</tr>
					</thead>
					<tbody>
						{legalTexts.docs?.map(legalText => (
							<tr key={legalText._id}>
								<td>{legalText.name}</td>
								<td className='flex gap-3'>
									<CheckRole has='view_legal_texts'>
										<Link
											to={`/legal-texts/${legalText._id}`}
											className='bg-black hover:bg-gray-700 px-2 py-1 rounded-md ease-in-out duration-200'
										>
											<img className='w-[25px]' src='/img/view.svg' alt='' />
										</Link>
									</CheckRole>
									<CheckRole has='delete_legal_texts'>
										<DangerButton onClick={() => handleDelete(legalText._id)} />
									</CheckRole>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				<Paginator meta={legalTexts} setPage={setPage} />
			</Card>
			<Modal show={showModal} onClose={closeModal}>
				<form onSubmit={handleAddLegal}>
					<H2>{l('add_legal_text')}</H2>
					<Input label={l('name')} reference={nameRef} />
					<Button type='secondary' full>
						{l('add')}
					</Button>
				</form>
			</Modal>
		</>
	)
}

export default LegalTextsList
